var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st3{opacity:0.75;fill:#E6E6E6;}\r\n\t.st4{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15.5,5.5 10.5,10.5 10.5,77.5 81.5,93.5 86.5,88.5 86.5,21.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "10.5,10.5 81.5,26.5 86.5,21.5  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 81.5,
    y1: 26.5,
    x2: 81.5,
    y2: 93.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 13.67,
    y1: 7.33,
    x2: 84.53,
    y2: 23.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 84.53,
    y1: 90.47,
    x2: 84.53,
    y2: 23.47
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "32.71,29.28 32.71,55.92 64.63,63.24 64.63,36.59  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "32.71,29.28 28.56,28.33 28.56,60.08 64.63,68.34 64.63,63.24 32.71,55.92  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.71,24.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "32.71,29.28 64.63,36.59 64.63,63.24  "
  })), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 32.71,
    y1: 55.92,
    x2: 28.56,
    y2: 60.08
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWindow);
export default __webpack_public_path__ + "static/media/IconWindow.f61eb7ce55085b26873671eed7194c83.svg";
export { ForwardRef as ReactComponent };